import Sunset from "../../../../contents/docs/self-host/_snippets/sunset-disclaimer.mdx";
import ResizeDiskRequirementsSnippet from "../../../../contents/docs/runbook/snippets/resize-disk-requirements.mdx";
import * as React from 'react';
export default {
  Sunset,
  ResizeDiskRequirementsSnippet,
  React
};